import React, { useEffect, useRef, useState } from 'react';
import LocalPrintshopRoundedIcon from '@material-ui/icons/LocalPrintshopRounded';
import { printRef } from 'utils/functions';
import { displayDateTime } from 'reducers/TimeReducer';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme) => ({
  iframe: {
    border: 'none',
    overflow: 'hidden',
    width: 1,
    height: 1,
  },
  tableWrap: {
    display: 'none',
  },
}));

function TableCreator(props) {
  const { data, cols } = props;

  const formatBool = (str) => {
    if (str === true) return 'YES';
    if (str === false) return 'NO';
    return str;
  };

  const formatValue = (str, format = null) => {
    if (str != null && str != undefined) {
      if (format === 'date' || (typeof str === 'string' && !isNaN(Date.parse(str))))
        return displayDateTime(str);
      else if (format === 'bool' || typeof str === 'boolean') return formatBool(str);
      else return str ?? '';
    }
  };

  return (
    <table>
      <thead>
        <tr>
          {cols.map((c) => (
            <th key={`header-${c.headerName}`}>{c.headerName}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr key={`${item.id}-row`}>
            {cols.map((c) => (
              <td key={`${item.id}-${c.field}`}> {formatValue(item[c.field], c.format)} </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function PrintsSearch3(props) {
  const classes = useStyles();
  const { title, data, cols, kbdKey, print } = props;
  const ref = useRef();
  const [printFlag, setPrintFlag] = useState(false);

  useEffect(() => {
    if (kbdKey === 'Ctrl+KeyL') handlePrint();
  }, [kbdKey]);

  useEffect(() => {
    if (print) handlePrint();
  }, [print]);

  const handlePrint = async () => {
    await setPrintFlag(true);
    printRef(ref, title);
  };

  const filterColumns = (columns) => columns.filter((col) => !col.hide);

  useEffect(() => {
    return () => {
      setPrintFlag(false);
    };
  });
  return (
    <div>
      {/* <Fab size="small" color="secondary" onClick={print}>
        <LocalPrintshopRoundedIcon />
      </Fab> */}
      <iframe id="print-iframe" className={classes.iframe}></iframe>
      {printFlag && (
        <div className={classes.tableWrap} ref={ref}>
          <TableCreator data={data} cols={filterColumns(cols)} />
        </div>
      )}
    </div>
  );
}

export default PrintsSearch3;
